import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { AREAS, areasFor } from "@/lib/menu";

/** Applica la configurazione salvata (ordine, nomi, voci nascoste, voci nuove) ai menu di default. */
export const applyMenuConfig = (aree, cfg) => {
  if (!cfg || !cfg.length) return aree;
  const byKey = Object.fromEntries(aree.map((a) => [a.key, a]));
  const usate = new Set();
  const out = [];
  cfg.forEach((ca) => {
    const base = byKey[ca.key];
    if (!base || ca.hidden) { if (base) usate.add(base.key); return; }
    usate.add(base.key);
    const perId = Object.fromEntries(base.items.map((i) => [i.testid, i]));
    const viste = new Set();
    const items = [];
    (ca.items || []).forEach((ci) => {
      const bi = perId[ci.id];
      viste.add(ci.id);
      if (ci.hidden) return;
      if (bi) items.push({ ...bi, label: ci.label || bi.label });
      else if (ci.custom && ci.to && ci.label) items.push({ to: ci.to, label: ci.label, testid: ci.id, roles: base.items[0]?.roles || [] });
    });
    base.items.forEach((bi) => { if (!viste.has(bi.testid)) items.push(bi); });
    if (items.length) out.push({ ...base, title: ca.title || base.title, items });
  });
  aree.forEach((a) => { if (!usate.has(a.key)) out.push(a); });
  return out;
};

/** Menu visibile all'utente: default filtrati per ruolo + configurazione salvata. */
export const useMenu = (user) => {
  const [cfg, setCfg] = useState(null);
  const load = useCallback(() => {
    if (!user) return;
    api.get("/menu-config").then((r) => setCfg(r.data.areas || [])).catch(() => setCfg([]));
  }, [user]);
  useEffect(() => { load(); }, [load]);
  return { areas: applyMenuConfig(areasFor(user), cfg), cfg, reload: load, pronto: cfg !== null };
};

/** Struttura completa (senza filtro ruoli) per la pagina Configurazione Menu. */
export const fullMenu = (cfg) => applyMenuConfig(AREAS.map((a) => ({ ...a, items: [...a.items] })), cfg);
